import { createTheme } from '@mui/material/styles';
import { fontSize } from '@mui/system';

const theme = createTheme({
    palette:{
        primary: {
            main: '#006199'            
        },
        secondary: {
            main: 'rgb(4, 171, 223)'
        }
    },
    components: {
        MuiTypography:{
            styleOverrides: {
                root: {
                    "&.MuiTypography-h6": {
                        fontSize: '16px'
                    }
                }
            }
        }
    },
});

export default theme